import { render, staticRenderFns } from "./MapChart1.vue?vue&type=template&id=1dc63976&scoped=true&"
import script from "./MapChart1.vue?vue&type=script&lang=js&"
export * from "./MapChart1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc63976",
  null
  
)

export default component.exports